import moment from 'moment';
import _ from 'underscore';
import parseError from '../../parseError';

const createTour = async ({ finalFormValidation, createTourPreReq, state, userId, updateState, addTour, Toast, refreshPage, contextMenuSelection }) => {
  if (!finalFormValidation()) {
    return null;
  }
  if (createTourPreReq) {
    const resourceId = state.resource.id;
    const personnelData = createTourPreReq.resourcePersonnelData.data[0];
    const { unionId, contractId, rulesGRP, hourlyActivityFlag, rate, jobSalaryId } = personnelData;
    const { itemDetails } = state;
    const { timeZoneId, mealStartTime, tourComment, myTourComment, notificationComment, showBusy } = itemDetails;
    const parameters = {
      resourceId,
      dateTimeStartActual: moment(itemDetails.tourStartTime).format('YYYY-MM-DD HH:mm:ss'),   // may have timezone issue again
      dateTimeEndActual: moment(itemDetails.tourEndTime).format('YYYY-MM-DD HH:mm:ss'),
      unionId,
      contractId,
      contractRulesGroupId: rulesGRP,
      timeZoneId,
      createDefaultMeal: !mealStartTime ? true : false,
      userId,
      comment: tourComment && tourComment.trim().length > 0 ? tourComment : null,
      comment15: myTourComment && myTourComment.comment && myTourComment.comment.trim().length > 0 ? myTourComment.comment : null,
      notification: notificationComment && notificationComment.trim().length > 0 ? notificationComment : null,
      showBusy: showBusy || false,
      baseRateId: hourlyActivityFlag === 1 ? 3 : 0,
      baseOverrideType: hourlyActivityFlag === 1 ? 'EXP' : 'NON',
      baseOverride: hourlyActivityFlag === 1 ? rate : 0,
      jobSalaryId
    };

    // store tour parameters for optimistic re-ender
    itemDetails.tourParams = parameters;
    updateState({itemDetails});
    if (contextMenuSelection === 'Add Tour') {
      await updateState({
        crudLoading: false // clears the way for page refresh on addTour complete
      });
    }

    // add tour
    const { resource } = state;
    const { tourStartTime } = state.itemDetails;
    const date = moment(tourStartTime).format('M/D/YYYY (ddd)');
    let notification = {type: 'success', message: 'Tour Added', description: `For ${resource.name} on ${date}`};
    try {
      await addTour(parameters);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        updateState({
          crudError: {
            failedAction: 'addTour',
            message: parseError(error)
          }
        });
        console.log(error);
        notification = {
            type: 'error',
            message: "Adding Tour Failed",
            description: `For [${resource.name} on ${date}]: ${parseError(error)}`
          };
        }
    }
    Toast(notification);
    refreshPage();
  }
}

export default createTour;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/tour/createTour.js